import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
const founders = [{
  name: 'Rob Frid',
  title: 'Founder & President of Development',
  slug: 'rob-frid',
  photo: 'https://cdn.magicpatterns.com/uploads/tNKtzo6iMqSY4iPn9J184Z/5752.png',
  actionPhoto: 'https://cdn.magicpatterns.com/uploads/drnjLYkADkGvq7ohwJ1YTF/5754.png',
  bio: 'A Canadian former minor-league hockey player turned hockey skills instructor, development advisor, and player placement director. Drafted by the London Knights of the OHL, Rob spent nearly nine seasons in professional hockey across the ECHL, CHL, WCHL, UHL, and U Sports.',
  quote: "We don't just build players; we build resilient individuals ready for any challenge the game throws at them."
}];
export const FoundersSection = () => {
  return <section id="team" className="py-24 bg-navy-800 relative" data-id="element-102" data-mp="bz2wws72kl8i">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-103" data-mp="c0mgosrxpef1">
        <div className="text-center mb-16" data-id="element-104" data-mp="21e1ntmyr3gqn">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="text-4xl md:text-5xl font-bold text-white mb-4 uppercase tracking-tight" data-id="element-105" data-mp="21h7bcxrqeak9">
            The Team Behind <span className="text-ice-500" data-id="element-106" data-mp="1dq1zsustq4fr">UHD</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-300 max-w-2xl mx-auto" data-id="element-107" data-mp="1dnyyhem80ovq">
            Mentorship from a former professional hockey player with an
            extensive amount of experience and a wide network of contacts.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:gap-12 max-w-3xl mx-auto" data-id="element-108" data-mp="33tvkml0al7ru">
          {founders.map((founder, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-navy-900 border border-navy-700 p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-109" data-mp="38t854z3oy2r9" data-mpi={index}>
              {/* Decorative corner */}
              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-navy-700 m-4 opacity-50" data-id="element-110" data-mp="4dfaur2pa6rt"></div>

              <div className="flex flex-col sm:flex-row gap-6 items-start mb-8" data-id="element-111" data-mp="1oyvka28k94qt">
                <div className="w-32 h-36 shrink-0 rounded-sm overflow-hidden border-2 border-gold-500 shadow-lg shadow-gold-500/10 bg-navy-700" data-id="element-112" data-mp="1kvpib6shdzq5">
                  <img src={founder.photo} alt={founder.name} className="w-full h-full object-cover object-center" data-id="element-113" data-mp="1b5me0afwszci" />
                </div>
                <div data-id="element-114" data-mp="116oq99qb59uk">
                  <h3 className="text-2xl font-bold text-white mb-1" data-id="element-115" data-mp="116f2lssqjes1">
                    {founder.name}
                  </h3>
                  <p className="text-ice-500 font-semibold text-sm uppercase tracking-wider mb-4" data-id="element-116" data-mp="x7pf37dzgguo">
                    {founder.title}
                  </p>
                  <p className="text-slate-300 leading-relaxed mb-6" data-id="element-117" data-mp="2rjw0ez0lce0p">
                    {founder.bio}
                  </p>
                  <Link to={`/${founder.slug}`} className="inline-flex items-center text-gold-500 hover:text-gold-400 font-bold transition-colors group" data-id="element-118" data-mp="2ml2nb7p7up12">
                    Read Full Bio
                    <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-119" data-mp="1a97ftcf7hjxa" />
                  </Link>
                </div>
              </div>

              <div className="bg-navy-800/50 p-6 rounded-sm border-l-4 border-ice-500 italic text-slate-400" data-id="element-120" data-mp="1f9v801f686t3">
                "{founder.quote}"
              </div>

              {/* Action Photo */}
              <div className="mt-6 rounded-sm overflow-hidden border border-navy-700 h-56 bg-navy-700" data-id="element-121" data-mp="15bp2zay2ikk0">
                <img src={founder.actionPhoto} alt={`${founder.name} in action`} className="w-full h-full object-cover object-center" data-id="element-122" data-mp="vk19z5lv4vgf" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};